import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import * as actions from '../../api/actions'
import { getConfiguration } from '../../configuration'

export interface Actions {
	fetchAppMetaData: (onError: (error: Error | Response) => void) => void
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	fetchAppMetaData: (onError: (error: Error | Response) => void) => {
		const platform = getConfiguration().getPlatform()
		dispatch(actions.fetchAppMetaData.started({ devicePlatform: platform, onError }))
	},
})

export default (Component: React.ComponentType<Actions>) => connect(undefined, mapDispatchToProps)(Component)
